import {
  ADD_FAVOURITE_PROJECT_ISSUE,
  ADD_FAVOURITE_PROJECT_ISSUE_SUCCESS,
  FETCH_PROJECT_ISSUE,
  FETCH_PROJECT_ISSUE_SUCCESS,
  FETCH_ALL_PROJECT_ISSUE,
  FETCH_ALL_PROJECT_ISSUE_SUCCESS,
  FILTER_PROJECT_ISSUE,
  GET_ALL_PROJECT_ISSUE,
  GET_UNSELECTED_ALL_PROJECT_ISSUE,
  HANDLE_PROJECT_ISSUE_REQUEST_CLOSE,
  HIDE_PROJECT_ISSUE_LOADER,
  SHOW_PROJECT_ISSUE_LOADER,
  ON_ADD_PROJECT_ISSUE,
  ON_ADD_JIRA_PROJECT_ISSUE,
  ON_ALL_PROJECT_ISSUE_SELECT,
  ON_PROJECT_ISSUE_CLOSE,
  ON_JIRA_PROJECT_ISSUE_CLOSE,
  ON_PROJECT_ISSUE_SELECT,
  ON_DELETE_PROJECT_ISSUE,
  ON_DELETE_PROJECT_ISSUE_SUCCESS,
  ON_FILTER_SELECTED_PROJECT_ISSUE,
  ON_FILTER_PROJECT_ISSUE_OPTION_SELECT,
  ON_SAVE_PROJECT_ISSUE,
  ON_SAVE_PROJECT_ISSUE_SUCCESS,
  ON_SAVE_JIRA_PROJECT_ISSUE,
  ON_TOGGLE_PROJECT_ISSUE_DRAWER,
  SHOW_PROJECT_ISSUE_MESSAGE,
  UPDATE_SEARCH_PROJECT_ISSUE,
  ON_SAVE_PROJECT_ISSUE_CACHE_SUCCESS,
  SET_PROJECT_ISSUE,
} from 'constants/ActionTypes';

export const onSaveProjectIssueCacheSuccess = (payload) => {
  return {
      type: ON_SAVE_PROJECT_ISSUE_CACHE_SUCCESS,
      payload
  };
};
export const fetchProjectIssue = (payload) => {
  return {
      type: FETCH_PROJECT_ISSUE,
      payload
  };
};
export const setProjectIssue = (payload) => {
  return {
      type: SET_PROJECT_ISSUE,
      payload
  };
};
export const fetchProjectIssueSuccess = (payload) => {
  return {
      type: FETCH_PROJECT_ISSUE_SUCCESS,
      payload
  };
};
// payload is boolesn - true is to use the cache - false - retrieve from api every time
export const fetchProjectIssues = (payload) => {
  return {
      type: FETCH_ALL_PROJECT_ISSUE,
      payload
  };
};
export const fetchProjectIssuesSuccess = (payload) => {
  return {
      type: FETCH_ALL_PROJECT_ISSUE_SUCCESS,
      payload
  };
};
export const showProjectIssueMessage = (message) => {
  return {
      type: SHOW_PROJECT_ISSUE_MESSAGE,
      payload: message
  };
};
export const addFavouriteProjectIssue = (payload) => {
  return {
      type: ADD_FAVOURITE_PROJECT_ISSUE,
      payload
  };
};
export const addFavouriteProjectIssueSuccess = (payload) => {
  return {
      type: ADD_FAVOURITE_PROJECT_ISSUE_SUCCESS,
      payload
  };
};
export const onProjectIssueSelect = (payload) => {
  return {
      type: ON_PROJECT_ISSUE_SELECT,
      payload
  };
};
export const onAddProjectIssue = () => {
  return {
      type: ON_ADD_PROJECT_ISSUE,
      payload: ''
  };
};
export const onAddJiraProjectIssue = () => {
  return {
      type: ON_ADD_JIRA_PROJECT_ISSUE,
      payload: ''
  };
};
export const onProjectIssueClose = () => {
  return {
      type: ON_PROJECT_ISSUE_CLOSE,
      payload: ''
  };
};
export const onJiraProjectIssueClose = () => {
  return {
      type: ON_JIRA_PROJECT_ISSUE_CLOSE,
      payload: ''
  };
};
export const onFilterProjectIssueOptionSelect = (payload) => {
  return {
      type: ON_FILTER_PROJECT_ISSUE_OPTION_SELECT,
      payload
  };
};
export const onSaveProjectIssue = (payload) => {
  return {
      type: ON_SAVE_PROJECT_ISSUE,
      payload
  };
};
export const onSaveJiraProjectIssue = (payload) => {
  return {
      type: ON_SAVE_JIRA_PROJECT_ISSUE,
      payload
  };
};
export const onSaveProjectIssueSuccess = (data) => {
  return {
      type: ON_SAVE_PROJECT_ISSUE_SUCCESS,
      payload: data
  };
};
export const onDeleteProjectIssue = (payload) => {
  return {
      type: ON_DELETE_PROJECT_ISSUE,
      payload
  };
};
export const onDeleteProjectIssueSuccess = (payload) => {
  return {
      type: ON_DELETE_PROJECT_ISSUE_SUCCESS,
      payload
  };
};
export const onFilterSelectedProjectIssue = () => {
  return {
      type: ON_FILTER_SELECTED_PROJECT_ISSUE,
      payload: ''
  };
};
export const filterProjectIssue = (payload) => {
  return {
      type: FILTER_PROJECT_ISSUE,
      payload
  };
};
export const getAllProjectIssue = () => {
  return {
      type: GET_ALL_PROJECT_ISSUE,
      payload: ''
  };
};
export const getUnselectedAllProjectIssue = () => {
  return {
      type: GET_UNSELECTED_ALL_PROJECT_ISSUE,
      payload: ''
  };
};
export const onAllProjectIssueSelect = () => {
  return {
      type: ON_ALL_PROJECT_ISSUE_SELECT,
      payload: ''
  };
};
export const updateSearchProjectIssue = (payload) => {
  return {
      type: UPDATE_SEARCH_PROJECT_ISSUE,
      payload
  };
};
export const onToggleProjectIssueDrawer = () => {
  return {
      type: ON_TOGGLE_PROJECT_ISSUE_DRAWER,
  };
};
export const handleProjectIssueRequestClose = () => {
  return {
      type: HANDLE_PROJECT_ISSUE_REQUEST_CLOSE,
  };
};
export const showProjectIssueLoader = () => {
  return {
      type: SHOW_PROJECT_ISSUE_LOADER,
  };
};
export const hideProjectIssueLoader = () => {
  return {
      type: HIDE_PROJECT_ISSUE_LOADER,
  };
};



// WEBPACK FOOTER //
// ./actions/projectIssue.js